var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import DOMPurify from 'dompurify';
import QuestionnaireOrg from "../../../organisms/jsQuestionnaire/jsQuestionnaire";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { OverallExperienceAction, OverallExperienceFormAction, } from "../../../../redux/actions/job_seeker_questionnaire";
import { questionnaireTimer } from "../../../../utils/QuestionnaireTimer";
import { getQuestionnaireAttemptVariant, getQuestionnaireProgressWidth, isMilestoneAttempt, } from "../../../../utils/questionnaireProgress";
/**
 * The Overall Experience Questionnaire Page
 * This will need to call all relevant APIs to get the values.
 * @param props
 * @returns
 */
function OverallExperienceQuestionnaire() {
    var navigate = useNavigate();
    var dispatch = useDispatch();
    var _a = useState(''), error = _a[0], setError = _a[1];
    var _b = useState(false), isSubmitting = _b[0], setIsSubmitting = _b[1];
    //using selector hook to fetch data from the reducer
    var _c = useSelector(function (state) { return state.rootReducer.JobSeekerQuestionnaireReducer; }), overallExperienceData = _c.overallExperienceData, error_overallExperience = _c.error_overallExperience, loading = _c.loading, overallExperienceFormData = _c.overallExperienceFormData, success_overallExperience_form = _c.success_overallExperience_form;
    var loginData = useSelector(function (state) { return state.rootReducer.userReducer; }).loginData;
    useEffect(function () {
        questionnaireTimer.startSection("Overall Outcomes");
        // Antecedents prefetches this section already; only fetch if it's
        // not already cached in the store (e.g. direct navigation to this page).
        if (!overallExperienceData || overallExperienceData.length === 0) {
            dispatch(OverallExperienceAction());
        }
    }, [dispatch]);
    var quesAttemptDetails = useSelector(function (state) { return state.rootReducer.dashboardReducer.quesAttemptDetails; });
    var milestoneAttempt = isMilestoneAttempt(quesAttemptDetails);
    //function to submit the input user data
    var handleFormSubmit = function (formData) {
        questionnaireTimer.endSection("Overall Outcomes");
        // Record Q2 total completion time
        var timingData = questionnaireTimer.onQuestionnaireComplete();
        console.log("\u2705 Q2 jobseeker questionnaire time: ".concat((timingData.totalSeconds / 60).toFixed(2), " minutes"));
        var sanitizedData = Object.keys(formData).reduce(function (acc, key) {
            acc[key] = DOMPurify.sanitize(formData[key]);
            return acc;
        }, {});
        // Add Q2 timing data to submission
        var submissionData = __assign(__assign({}, sanitizedData), { completion_time_seconds: Math.round(timingData.totalSeconds) });
        setIsSubmitting(true);
        dispatch(OverallExperienceFormAction(submissionData, loginData));
        // Clear Q2 timing data after successful submission
        questionnaireTimer.clearTimings();
    };
    var handleBackBtn = function () {
        navigate(milestoneAttempt ? "/questionnaire/global" : "/questionnaire/adviserImpact");
    };
    useEffect(function () {
        if (success_overallExperience_form && isSubmitting) {
            navigate('/questionnaire/transition');
        }
    }, [success_overallExperience_form, isSubmitting, navigate]);
    return (_jsxs("div", __assign({ className: "" }, { children: [error && _jsx("div", __assign({ className: "error-message" }, { children: error })), _jsx(QuestionnaireOrg, { title: "Overall Outcomes", content: "As a participant on this programme, you will be interacting with your adviser. In order to ensure that you get the best from the relationship with your adviser, we want to understand what you feel you have committed to do, but also what they have committed to do, to support to towards employment. Please respond truthfully and trust your initial reactions to the following statements. To what extent have you made the following commitments or obligations to your adviser?", data: overallExperienceData, responses: overallExperienceFormData, loading: !overallExperienceData || overallExperienceData.length === 0, handleSubmit: handleFormSubmit, handleBackBtn: handleBackBtn, classname: "overallExperience-w", width: getQuestionnaireProgressWidth("overallExperience", getQuestionnaireAttemptVariant(quesAttemptDetails)) })] })));
}
export default OverallExperienceQuestionnaire;
